// extracted by mini-css-extract-plugin
export var container = "privacy-module--container--H0b_5";
export var header = "privacy-module--header--1wIzF";
export var language = "privacy-module--language--3oBje";
export var containerInfo = "privacy-module--containerInfo--1Yxx-";
export var text = "privacy-module--text--eTvj8";
export var details = "privacy-module--details--vHTFz";
export var links = "privacy-module--links--3nBAJ";